import React from "react";
import striptags from "striptags";
import { replaceArticlesPath } from "../../services/urlString";
const ArticleMetaTags = ({ article }) => {
  const url =
    article.get_external_url.indexOf("agrarlex") > -1
      ? replaceArticlesPath(article.get_external_url)
      : article.get_external_url;

  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@topagrar_PL" />
      <meta name="twitter:title" content={article.title} />
      <meta name="twitter:description" content={striptags(article.lead)} />
      <meta name="twitter:image" content={article.image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={article.title} />
      <meta property="og:description" content={striptags(article.lead)} />
      <meta property="og:image" content={article.image} />
    </>
  );
};

export default ArticleMetaTags;
